import { createDeleteEntityAction, createResetEntityAction, createSaveEntityAction } from '../generic/entityAction';

export const FOOD_PRIVILEGE_ENROLLMENT = 'FOOD_PRIVILEGE_ENROLLMENT';

export default {
    save: createSaveEntityAction(() => '/api/enrollment/food-privileges', FOOD_PRIVILEGE_ENROLLMENT),
    delete: createDeleteEntityAction(privilegeId => `/api/enrollment/food-privileges/${privilegeId}`, FOOD_PRIVILEGE_ENROLLMENT),
    reset: createResetEntityAction(FOOD_PRIVILEGE_ENROLLMENT),
};